import "./styles/HomeNew.css";
import "./styles/SocialIcons.css";

const FacebookIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  </svg>
);

const InstagramIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
  </svg>
);

const LinkedInIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect x="2" y="9" width="4" height="12" />
    <circle cx="4" cy="4" r="2" />
  </svg>
);

const Footer = () => {
  return (
    <footer className="foot">
      <div className="foot__inner">

        {/* Brand */}
        <div className="foot__brand">
          <a href="/" className="foot__logo-wrap">
            <img src="/images/homePage/Logo.jpg" alt="FBT Logo" width="44" height="44" className="foot__logo-img" />
            <span className="foot__logo">FBT</span>
          </a>
          <p>For A Better Tomorrow<br />Bloomington, Illinois</p>
        </div>

        {/* Nav links */}
        <nav className="foot__nav">
          <a href="/">Home</a>
          <a href="/about">About Us</a>
          <a href="/projects">Projects</a>
          <a href="/kitefest">Kite Fest</a>
          <a href="/yicu">YICU</a>
          <a href="/ygc">YGC</a>
          <a href="/steam">STEAM</a>
          <a href="/yvc">YVC</a>
          <a href="/grant">Grant</a>
          <a href="/contact">Contact Us</a>
        </nav>

        {/* Social + CTA — stacked with clear gap */}
        <div className="foot__right">
          <div className="foot__socials">
            <a
              href="https://www.facebook.com/4ABetterTomorrow/"
              target="_blank"
              rel="noopener noreferrer"
              className="foot__social foot__social--fb"
              aria-label="Facebook"
            >
              <FacebookIcon />
            </a>
            <a
              href="https://www.instagram.com/4abettom/"
              target="_blank"
              rel="noopener noreferrer"
              className="foot__social foot__social--ig"
              aria-label="Instagram"
            >
              <InstagramIcon />
            </a>
            <a
              href="https://www.linkedin.com/company/4abettom/"
              target="_blank"
              rel="noopener noreferrer"
              className="foot__social foot__social--li"
              aria-label="LinkedIn"
            >
              <LinkedInIcon />
            </a>
          </div>

          <a href="/donate" className="foot__cta">Donate ↗</a>
        </div>

      </div>

      {/* Bottom bar */}
      <div className="foot__copy">
        <span>© {new Date().getFullYear()} For A Better Tomorrow. All rights reserved.</span>
        <span>forbettertomorrow.org</span>
      </div>
    </footer>
  );
};

export default Footer;